import { render, staticRenderFns } from "./MedicalInsuranceLevels.vue?vue&type=template&id=01369a8b&"
import script from "./MedicalInsuranceLevels.vue?vue&type=script&lang=js&"
export * from "./MedicalInsuranceLevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports